// SPDX-License-Identifier: AGPL-3.0-or-later

import {canReportMessage} from '@app/features/channel/components/MessageActionUtils';
import type {Message} from '@app/features/messaging/models/Message';
import {openReportMessageModal} from '@app/features/moderation/utils/ReportActionUtils';
import {ReportMessageIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

interface ReportMessageMenuItemProps {
	message: Message;
	onClose: () => void;
}
export const ReportMessageMenuItem: React.FC<ReportMessageMenuItemProps> = observer(({message, onClose}) => {
	const {t} = useLingui();
	const handleReportMessage = useCallback(() => {
		if (!canReportMessage(message)) {
			return;
		}
		onClose();
		openReportMessageModal(message);
	}, [message, onClose]);
	if (!canReportMessage(message)) {
		return null;
	}
	return (
		<MenuItem icon={<ReportMessageIcon size={16} />} onClick={handleReportMessage} danger>
			{t`Report Message`}
		</MenuItem>
	);
});
